<template>
  <div class="width98 margin-auto backwhite pad-bot40">
    <!-- 检索 -->
    <div class="width98 margin-auto pad-top20">
      <p class="Patent-abstract pad-left10">发起成果出售信息</p>
      <el-form ref="form" :model="form" class="pad-top10 flex-aroundwrap">
        <el-form-item label="成果名称" class="width32" prop="tech_keyword">
          <el-input
            placeholder="请输入成果名称"
            v-model="form.title"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择成果" class="width32" prop="well_known_used">
          <el-select
            v-model="form.achievements_id"
            placeholder="请选择成果"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in page"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成果分类" class="width32" prop="well_known_used">
          <!-- <el-select
            v-model="form.cate_id"
            placeholder="请选择成果分类"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in pagecate"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
          <el-input
            placeholder="请选择技术分类"
            v-model="form.ipc"
            class="width100"
            @focus="smallchange()"
          ></el-input>
        </el-form-item>
        <el-form-item label="出售截止时间" class="width32" prop="start_at">
          <el-date-picker
            class="inputDeep"
            v-model="form.end_date"
            type="date"
            placeholder="请选择出售截止时间"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="当前权利人" class="width32" prop="upsteam">
          <el-input
            placeholder="请输入当前权利人"
            v-model="form.author"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" class="width32" prop="downsteam">
          <el-input
            placeholder="请输入联系电话"
            v-model="form.phone"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="出售价格" class="width32" prop="tech_keyword">
          <el-input
            placeholder="请输入出售价格"
            v-model="form.price"
            class="width100"
          ></el-input>
        </el-form-item>
        <el-form-item label="转让方式" class="width32" prop="well_known_used">
          <el-select
            v-model="form.transfer_way"
            placeholder="请选择转让方式"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in ferway"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业" class="width32" prop="well_known_used">
          <el-select
            v-model="form.industry"
            placeholder="请选择行业"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in industry"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成果封面" class="width98">
          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="handleAvatarSuccesshead"
            :on-error="handleerrorhead"
            :data="userhead"
            :headers="head"
            style="margin-top: 40px"
          >
            <img v-if="form.pictureurl" :src="form.pictureurl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="" class="width98">
          <p class="textalign-left dimensional f14 margin-bot10">
            <span>技术成熟度说明</span>
          </p>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="form.maturity"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="width98">
          <p class="textalign-left dimensional f14 margin-bot10">
            <span>详细说明</span>
          </p>
          <wangEditor
            v-model="form.remark"
            :isClear="isClear"
            class="textalign-left"
          ></wangEditor>
        </el-form-item>
      </el-form>
      <div class="textalign-right margin-right20 margin-top20">
        <el-button @click="dialogVisiblefalse()">取 消</el-button>
        <el-button type="primary" @click="toproductmanagement()">
          保存
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="ipcdilog"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left f18">项目分类</p>
      <div class="margin-top20">
        <el-tree
          class="isdisabled"
          :data="ipcdata"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :check-on-click-node="true"
          :check-strictly="true"
          :show-checkbox="checkbox"
          @check="treeCheck"
          @node-expand="nodeExpand"
          node-key="title"
          ref="treeForm"
          :highlight-current="true"
        ></el-tree>
      </div>
      <p class="textalign-right margin-top20">
        <el-button type="primary" @click="ipctitle()">确 定</el-button>
        <el-button @click="ipcdilog = false">关 闭</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { entachievementsindex, patentleveldata } from "@/api/Center/Center.api";
import {
  productcate,
  productsave,
  entproductgoodtransferway,
  entproductgoodindustry,
} from "@/api/business/business.api";
import wangEditor from "@/components/wangEditor";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      ipcdilog: false,
      ipcdata: [],
      defaultProps: {
        children: "sub",
        label: "detail",
      },
      checkbox: false,
      page: [],
      pagecate: [],
      ferway: [],
      industry: [],
      imageUrl: "",
      form: {
        title: "",
        phone: "",
        end_date: "",
        author: "",
        cate_id: "",
        price: "",
        achievements_id: "",
        // image: "http://dummyimage.com/400x400",
        remark: "",
        picture: "",
        pictureurl: "",
        maturity: "",
        industry: "",
        transfer_way: "",
        ipc: "",
      },
      userhead: {
        images: "",
      },

      picturehead: "",
      mentSuccess: true,
      mousechanges: "",
      Apisrc: "",
      Apisrcs: "",
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
      wangEditorDetail: "",
      filebox: [],
      files: [],
    };
  },
  components: { wangEditor },
  methods: {
    handleNodeClick(data, e, node) {
      data.sub = [{}];

      if (data.sub.length != 0) {
        patentleveldata({ pid: data.id }).then((res) => {
          if (res.data.code == 200) {
            data.sub = res.data.data;
            res.data.data.forEach((i) => {
              if (i.sub.length != 0) {
                i.disabled = true;
                this.checkbox = false;
              } else {
                this.checkbox = true;
                i.disabled = false;
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.form.ipc = data.title;
      }
    },
    treeCheck: function (node, list) {
      //node 该节点所对应的对象、list 树目前的选中状态对象
      //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点

      this.form.ipc = node.title;
      if (list.checkedKeys.length == 2) {
        //单选实现
        this.$refs.treeForm.setCheckedKeys([node.title]);
      }
    },
    ipctitle() {
      this.ipcdilog = false;
    },
    nodeExpand(data, e, node) {
      data.sub = [{}];
      if (data.sub.length != 0) {
        patentleveldata({ pid: data.id }).then((res) => {
          if (res.data.code == 200) {
            data.sub = res.data.data;
            res.data.data.forEach((i) => {
              if (i.sub.length != 0) {
                i.disabled = true;
                this.checkbox = false;
              } else {
                this.checkbox = true;
                i.disabled = false;
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.form.ipc = data.title;
      }
    },
    smallchange() {
      this.ipcdilog = true;
    },
    // 上传附件
    handleAvatarSuccesshead(response, res, file) {
      this.form.picture = res.name;
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        if (response.data.url.indexOf("http") == -1) {
          this.form.pictureurl = this.picturehead + response.data.url;
        } else {
          this.form.pictureurl = response.data.url;
        }
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    handleerrorhead(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    toproductmanagement() {
      productsave({
        title: this.form.title,
        phone: this.form.phone,
        end_date: this.form.end_date,
        author: this.form.author,
        // cate_id: this.form.cate_id,
        ipc: this.form.ipc,
        price: this.form.price,
        achievements_id: this.form.achievements_id,
        image: this.form.pictureurl,
        remark: this.form.remark,
        maturity: this.form.maturity,
        industry_id: this.form.industry,
        transfer_way: this.form.transfer_way,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          this.$router.push({
            path: "/Results-trading/Achievement-entrustment",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialogVisiblefalse() {
      this.$router.push({
        path: "/Results-trading/Achievement-entrustment",
      });
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/oss_form";
    this.picturehead = window.g.Apisrc;
    // 成果
    entachievementsindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 分类
    // productcate({
    //   page: this.thisNum,
    // }).then((res) => {
    //   if (res.data.code == 200) {
    //     this.pagecate = res.data.data;
    //   } else {
    //     this.dialogVisiblenull = true;
    //     this.errormessage = res.data.msg;
    //   }
    // });
    patentleveldata({ pid: 0 }).then((res) => {
      if (res.data.code == 200) {
        this.ipcdata = res.data.data;
        res.data.data.forEach((i) => {
          i.disabled = true;
          this.checkbox = false;
          i.sub = [{}];
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 转让方式
    entproductgoodtransferway({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.ferway = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 行业
    entproductgoodindustry({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.industry = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.isdisabled >>> .is-disabled {
  display: none !important;
}
.isdisabled >>> .el-tree-node__content {
  display: flex;
  align-items: baseline;
  white-space: wrap;
  height: 100%;
  outline: 0;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}
.Patent-abstract {
  border-left: 4px solid #52c5cb;
  font-weight: 600;
  height: 20px;
  line-height: 20px;
}
.dimensional {
  padding: 20px 0 0 10px;
}
.picturecont {
  width: 100%;
  height: 100%;
  background-color: rgb(85 0 0 / 46%);
  position: absolute;
  text-align: center;
  /* top: 50%; */
  color: white;
  /* text-align: center; */
  z-index: 2;
}
.pictureimg {
  width: 100%;
  height: 110px;
}
.filebox {
  width: 100%;
  height: 110px;
  margin: 0 0 50px 0;
  border: 1px solid #efefef;
  position: relative;
}
.picspan {
  position: relative;
  top: 40%;
  z-index: 3;
}
.uploaddragger >>> .el-upload {
  width: 100%;
}
.uploaddragger >>> .el-upload-dragger {
  width: 100%;
  margin: auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #6e6d6d;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploaddragger >>> .el-upload-dragger:hover {
  border-color: #52c5cb;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  /* text-align: center; */
  border: 1px dashed #e5e5e5;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
}
.el-form-item {
  margin: 10px 0;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>